import React, {useEffect, useState} from 'react';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Container from 'reactstrap/lib/Container';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSearchPlus} from '@fortawesome/free-solid-svg-icons/faSearchPlus';
import {faSearchMinus} from '@fortawesome/free-solid-svg-icons/faSearchMinus';
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes';
import {faChevronLeft} from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import {faChevronRight, faDownload} from '@fortawesome/free-solid-svg-icons';
import {TransformComponent, TransformWrapper} from 'react-zoom-pan-pinch';
import {Document, Page} from 'react-pdf';
import {saveAs} from 'file-saver';
import {preloadImages} from './ImageLoadHelper';

const CustomLightbox = ({documents, selectedDocument, onDownload, onMoveSlide, onClose}) => {
    const [pdfClassName, setPdfClassName] = useState('pdf-canvas-fit');
    const [scale, setScale] = useState(1);
    const [page, setPage] = useState(1);
    const [pagesTotal, setPagesTotal] = useState(null);
    const [isDocumentLoaded, setIsDocumentLoaded] = useState(false);
    const [file, setFile] = useState(null);
    const [fileUrl, setFileUrl] = useState(null);
    const [documentIndex, setDocumentIndex] = useState(null);

    useEffect(() => {
        loadDocument();
    }, [selectedDocument.id]);

    const downloadResource = () => {
        let fileToDownload = documents.find(d => d.id === file.id).original_url;
        saveAs(fileToDownload, file.file_name || `photo_${file.id}`); // Put your image url here.
        onDownload && onDownload();
    };

    const loadDocument = () => {
        const currentFileIndex = documents.findIndex(p => p.id === selectedDocument.id);
        setDocumentIndex(currentFileIndex);
        setFile(documents[currentFileIndex]);
        setFileUrl(documents[currentFileIndex].original_url);
        setIsDocumentLoaded(false);
        if (['jpg', 'jpeg', 'png', 'webp'].some(format => documents[currentFileIndex].content_type.toLowerCase().includes(format))) {
            preloadImages([documents[currentFileIndex]], ['original_url'], () => setIsDocumentLoaded(true));
        } else {
            setIsDocumentLoaded(true);
        }
    };

    const onArrowClick = (direction) => {
        setIsDocumentLoaded(false);
        setScale(1);
        setPage(1);
        setPdfClassName('pdf-canvas-fit');
        onMoveSlide(direction, documentIndex, documents);
    };
    const fileTypeHandler = (fileUrl) => {
        if (['jpg', 'jpeg', 'png', 'webp'].some(format => selectedDocument.content_type.toLowerCase().includes(format))) {
            return (
                <TransformWrapper
                    scale={scale}
                    positionX={0}
                    positionY={0}
                >
                    <TransformComponent>
                        {isDocumentLoaded && <img className='lightbox-image'
                                                  alt={selectedDocument.alt}
                                                  src={documents.find(d => d.id === selectedDocument.id).original_url} />}
                    </TransformComponent>
                </TransformWrapper>
            );
        } else if (fileUrl.toLowerCase().includes('pdf')) {
            return (
                <div>
                    <Document
                        file={fileUrl}
                        onLoadSuccess={(e) => setPagesTotal(e._pdfInfo.numPages)}
                    >
                        <Page className={pdfClassName} scale={scale} pageNumber={page} />
                    </Document>
                    <div className='pdf-navbar'>
                        <button
                            disabled={page === 1}
                            onClick={() => setPage(page - 1)}
                            className='lightbox-button text-white mx-2 bg-transparent border-0' type='button'>
                            <FontAwesomeIcon icon={faChevronLeft} /></button>
                        <span>{page} of {pagesTotal}</span>
                        <button disabled={page >= pagesTotal}
                                className='lightbox-button text-white mx-2 bg-transparent border-0'
                                onClick={() => setPage(page + 1)}
                                type='button'><FontAwesomeIcon icon={faChevronRight} /></button>
                    </div>
                </div>);
        } else if (fileUrl.toLowerCase().includes('mp4')) {
            return <video style={{maxHeight: '90vh'}} preload='metadata' playsInline={true} controls={true} muted={true}
                          className='lightbox-video'
                          width='600px' height='400px' src={fileUrl}>
                <source src={fileUrl}
                        type='video/mp4;codecs="avc1.42E01E, mp4a.40.2"' />
                Your browser does not support the video tag.
            </video>;
        } else if (fileUrl.toLowerCase().includes('mov')) {
            return <video style={{maxHeight: '90vh'}} preload='metadata' playsInline={true} controls={true} muted={true}
                          className='lightbox-video'
                          width='600px' height='400px' src={fileUrl}>
            </video>;

        } else {
            return (<p className='text-center mx-auto'>Could not load this file.</p>);
        }
    };

    return (
        <Container style={{height: window.innerHeight}} className='div lightbox-modal position-fixed'>
            <Row className='lightbox-nav position-fixed fixed-top'>
                <Col className='text-left my-3 mx-3'>
                    <button
                        className='lightbox-button text-white mx-2 bg-transparent border-0'>{documentIndex + 1}/{documents.length}</button>
                </Col>
                <Col className='z-index text-right my-3 mx-3 d-flex justify-content-end'>
                    {isDocumentLoaded && (['jpg', 'jpeg', 'png'].some(format => selectedDocument.content_type.toLowerCase().includes(format)) || fileUrl.toLowerCase().includes('pdf')) &&
                        <React.Fragment>
                            <button onClick={downloadResource}
                                    className='lightbox-button text-white mx-2 bg-transparent border-0'
                            ><FontAwesomeIcon icon={faDownload} />
                            </button>
                            <button onClick={() => {
                                if (scale === 1 && fileUrl.toLowerCase().includes('pdf') && pdfClassName !== 'pdf-canvas') {
                                    setPdfClassName('pdf-canvas');
                                } else {
                                    setScale(scale + 0.5);
                                }
                            }}
                                    className='lightbox-button text-white mx-2 bg-transparent border-0'
                            ><FontAwesomeIcon icon={faSearchPlus} />
                            </button>
                            <button onClick={() => {
                                if (scale === 1 && fileUrl.toLowerCase().includes('pdf')) {
                                    setPdfClassName('pdf-canvas-fit');
                                } else {
                                    setScale(scale > 1 ? scale - 0.5 : 1);
                                }
                            }}
                                    className='lightbox-button text-white mx-2 bg-transparent border-0'
                            ><FontAwesomeIcon
                                icon={faSearchMinus} />
                            </button>
                        </React.Fragment>
                    }
                    <button className='lightbox-button text-white mx-2 bg-transparent border-0'
                            onClick={onClose}><FontAwesomeIcon icon={faTimes} /></button>
                </Col>
            </Row>
            <Row className='mx-auto lightbox-container position-absolute'>
                {documents.length > 1 && <button
                    className='lightbox-button button-control text-white position-absolute high-z-index prev'
                    onClick={() => onArrowClick('prev')}><FontAwesomeIcon icon={faChevronLeft} />
                </button>}
                {isDocumentLoaded && <div className='lightbox-wrapper'>
                    {fileTypeHandler(fileUrl)}
                </div>}
                {documents.length > 1 && <button
                    className='lightbox-button button-control text-white position-absolute high-z-index next'
                    onClick={() => onArrowClick('next')}><FontAwesomeIcon icon={faChevronRight} />
                </button>}
            </Row>
        </Container>

    );
};

export default CustomLightbox;


// WEBPACK FOOTER //
// ./src/common/CustomLightbox.js